<template>
    <v-item-group class="border" v-model="selected">
        <v-container class="py-0">
            <v-row>
                <v-col v-for="(item, index) in PatchTypesC({w:cutWidth,h:cutHeight})" :key="index" cols="4">
                    <v-item v-slot:default="{ active, toggle }">
                        <v-card :data-test-id="'patchTypes_'+item.cat" height="97px" width="176px"   class="v-btn text-center" :class="active?'active':''" :disabled="!activatecuts" @click="toggle">
                            <v-card-title class="body-2 pa-0 pt-2 text-center">
                                <v-spacer/>
                                <span>
                            {{ item.cat }}
                        </span>
                                <v-spacer/>
                            </v-card-title>
                            <v-card-text class="caption pa-0 text-center">
                                {{ item.name_full }}
                            </v-card-text>
                            <v-card-actions style="position: absolute; bottom: 0px">
                                <span class="card-price pa-0">{{ extraPrice(item) }} руб.</span>
                                <span class="card-cord ml-2 pa-0" v-if="item.cord>0">{{ item.cord }}<span v-if="item.cord==1"> слой корда</span> <span v-else> слоя корда</span></span>
                            </v-card-actions>
                        </v-card>
                    </v-item>
                </v-col>
                <v-col v-if="PatchTypesC({w:cutWidth,h:cutHeight}).length===0">
                    Измените параметры, нет подходящей латки
                </v-col>
                <v-col v-if="!selected && validation" style="color: #9d0006">
                    ! Выберите подходящую латку !
                </v-col>
            </v-row>
        </v-container>
    </v-item-group>
</template>
<script>
    export default {
        name: 'wheelPatch',
        props: ['side', 'validation'],
        data() {
            return {
                PatchTypes: [],
            }
        },
        computed: {
            isRunflat () {
                return this.$store.state.repair.wheels[this.side].data.isRunflat
            },
            radiusRate () {
                return this.$store.state.repair.wheels[this.side].data.radiusRate
            },
            hotVulcan () {
                return this.$store.state.repair.wheels[this.side].data.hotVulcan
            },
            activatecuts() {
                return this.$store.state.repair.wheels[this.side].data.cutWidth>0 && this.$store.state.repair.wheels[this.side].data.cutHeight>0
            },
            cutWidth(){
              return this.$store.state.repair.wheels[this.side].data.cutWidth
            },
            cutHeight(){
              return this.$store.state.repair.wheels[this.side].data.cutHeight
            },
            cutType(){
              return this.$store.state.repair.wheels[this.side].data.cutType
            },
            selected: {
                get() {
                    return this.$store.state.repair.selected[this.side]
                },
                set(value) {
                    this.$store.commit('repair/setSelected', [ value, this.side ])
                }
            },
        },
        watch: {
            selected(newval){
                let value = {}
                if (newval != null) {
                    //console.log('newval',newval)
                    value.PatchType = this.PatchTypes[newval].name_lite
                    value.PatchPrice = this.PatchTypes[newval].price
                    value.time_cold = this.PatchTypes[newval].time_cold
                    value.time_hot = this.PatchTypes[newval].time_hot
                    value.PatchSelected = this.PatchTypes[newval]
                    this.$store.commit('repair/changePatch', { side: this.side, value })
                } else {
                    value.PatchType = ''
                    value.PatchPrice = 0
                    value.PatchSelected = {}
                    this.$store.commit('repair/changePatch', { side: this.side, value })
                }
            }
        },
        methods: {
            extraPrice(value){
                let price = 0
                console.log('sss',value)
                if (this.radiusRate > 0 && value.extra_radius>0) {
                    price = value.price + Math.round(value.price / 100 * this.radiusRate)
                } else {
                    price = value.price
                }
                if (this.isRunflat && value.name_lite !== 'Грибок') {
                    price = price + Math.round(value.price / 100 * value.extra_runflat)
                }
                return price
            },
            PatchTypesC (value) {
                this.PatchTypes = []
                let count = 0
                let tempArr = []
                let hotVulc = this.hotVulcan
                let name = ['Эконом','Стандарт','Премиум']
                if (hotVulc) {
                    value.w = value.w + Math.round(value.w / 100 * 10)
                    value.h = value.h + Math.round(value.h / 100 * 10)
                }
                this.$store.state.repair.tyreRepairs.forEach((x) => {
                    if (count < 3) {
                        if (hotVulc || !!x.v_cold) {
                            if (this.cutType == 0)
                            {
                                if (x.bok_w >= value.w && x.bok_l >= value.h)
                                {
                                    x.cat = name[count]
                                    console.log('x',x)

                                    tempArr.push(x)
                                    count++
                                }
                            }
                            if (this.cutType == 1)
                            {
                                if (x.plech_w >= value.w && x.plech_l >= value.h)
                                {
                                    x.cat = name[count]
                                    console.log('x',x)
                                    tempArr.push(x)
                                    count++
                                }
                            }
                            if (this.cutType == 2)
                            {
                                if (x.beg_w >= value.w && x.beg_l >=value.h)
                                {
                                    x.cat = name[count]
                                    console.log('x',x)
                                    tempArr.push(x)
                                    count++
                                }
                            }
                        }
                    }
                })
                this.PatchTypes = tempArr
                return tempArr
            },
        }
    }
</script>
<style lang="scss" scoped>
    .active {
        background-color: #FFFBCD !important;
    }
    .card-price{
        font-size: 12px;
    }
    .card-cord{
        text-align: right;
        font-weight: 300;
        font-size: 9px;
    }
    .border {
        border-radius: 4px;
        border: thin solid rgba(0,0,0,.12);
    }
    .primary_bg_color {
        background-color: #FFFEEE !important;
    }
    .primary_bg_color .active {
        background-color: #FFFBCD !important;
    }
    .change_disk.v-btn-toggle .v-btn{
        height: 51px !important;
        width: 80px !important;
    }
    .change_disk.v-btn-toggle{
        height: 51px !important;
        width: 80px !important;
    }
    .tabs_icons_big {
        width: 40px;
        height: 40px;
    }
</style>
